import { BaseError } from "./base-error.js";
export class SchemaBuildError extends BaseError {
    static code = 'SchemaBuildError';
    static statusCode = 400;
    schema;
    cause;
    constructor(message = 'An error occurred while building the schema', { cause, schema, ...options } = {}) {
        super(message, options);
        this.schema = schema;
        this.cause = cause;
        this.stack = cause?.stack;
    }
}
